import React, { useState, useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Header from "../components/header";
import RowView from "../components/rowView";
import {
  getTrending,
  getPopularTV,
  getOnTheAir,
  getTopRatedTV,
  discoverTV,
  GENRES,
} from "../services/tmdb";

function Series() {
  const [heroItems, setHeroItems] = useState([]);
  const [popular, setPopular] = useState([]);
  const [onAir, setOnAir] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [hindi, setHindi] = useState([]);
  const [mystery, setMystery] = useState([]);

  useEffect(() => {
    async function fetchAll() {
      const [hero, pop, air, top, hi, myst] = await Promise.all([
        getTrending("tv", "week"),
        getPopularTV(),
        getOnTheAir(),
        getTopRatedTV(),
        discoverTV({ with_original_language: "hi" }),
        discoverTV({ with_genres: GENRES.MYSTERY }),
      ]);
      setHeroItems(hero?.results || []);
      setPopular(pop?.results || []);
      setOnAir(air?.results || []);
      setTopRated(top?.results || []);
      setHindi(hi?.results || []);
      setMystery(myst?.results || []);
    }
    fetchAll();
  }, []);

  return (
    <div>
      <NavBar series="active" />
      <Header items={heroItems} />
      <RowView heading="🔥 Popular Series" items={popular} />
      <RowView heading="📡 On The Air" items={onAir} />
      <RowView heading="⭐ Top Rated" items={topRated} />
      <RowView heading="🇮🇳 Hindi Series" items={hindi} />
      <RowView heading="🔍 Mystery & Thriller" items={mystery} />
      <hr style={{ color: "white" }}></hr>
      <Footer />
    </div>
  );
}

export default Series;
